var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsForRepair = function SvgPartsForRepair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.05,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.05 58.77a1 1 0 0 0-1 1V64a5 5 0 0 1-5 5h-20a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5v26.08a1 1 0 0 0 2 0V16a7 7 0 0 0-7-7h-20a7 7 0 0 0-7 7v48a7 7 0 0 0 7 7h20a7 7 0 0 0 7-7v-4.23a1 1 0 0 0-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60.93 55.9 40 35c1.49-2.35 1-6.09-1.34-8.4s-6.57-3.33-9.19-.71a1 1 0 0 0-.29.71 1 1 0 0 0 .29.7L33 30.8l-2.13 2.12-3.53-3.54a1 1 0 0 0-1.42 0c-2.62 2.63-1.67 6.82.71 9.2s6.05 2.83 8.41 1.33L56 60.85a3.5 3.5 0 0 0 5-5Zm-1.42 3.54a1.51 1.51 0 0 1-2.12 0L35.82 37.87a1 1 0 0 0-.7-.29 1 1 0 0 0-.71.29c-1.4 1.4-4.61 1-6.36-.71-1.46-1.45-2.22-3.81-1.31-5.55L30.17 35a1 1 0 0 0 1.41 0l3.54-3.53a1 1 0 0 0 0-1.42l-3.43-3.43c1.74-.91 4.09-.15 5.55 1.31 1.75 1.75 2.11 5 .71 6.36a1 1 0 0 0 0 1.42l21.56 21.61a1.46 1.46 0 0 1 .49 1.06 1.47 1.47 0 0 1-.49 1.06"
  })));
};
export default SvgPartsForRepair;